// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ":scope .el-table__cell a.el-button--mini[data-v-3e3140c0], :scope .el-table__cell button.el-button--mini[data-v-3e3140c0] {\n  padding: 7px;\n  margin-bottom: 5px;\n}\n:scope .el-table__cell .el-button + .el-button[data-v-3e3140c0] {\n  margin-left: 0;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
